import Dropdown, { DropdownProps } from '@anm/components/Dropdown';
import isServer from '@anm/helpers/is/isServer';
import { useEffect, useState, FC } from 'react';

import { DropdownButton, DropdownButtonWrapper } from './Wrapper';

type BuiltInDropdownProps = Partial<DropdownProps> & {
  maxWindowHeight: number;
  className?: string;
};

const BuiltInDropdown: FC<BuiltInDropdownProps> = ({
  maxWindowHeight,
  renderContent,
  children,
  className,
  ...dropdownProps
}) => {
  const [isTop, setTop] = useState(false);

  useEffect(() => {
    !isServer() && setTop(window.innerHeight < maxWindowHeight);
  }, [isServer()]);

  return (
    <DropdownButtonWrapper {...{ isTop, className }}>
      <Dropdown
        autoClose={false}
        onOpen={() => setTop(window.innerHeight < maxWindowHeight)}
        openByAction="hover"
        openerVariant="default"
        direction="to-bottom-no-arrow-static"
        renderContent={props => (props.isOpenContent ? renderContent?.(props) || null : null)}
        {...dropdownProps}
      >
        <DropdownButton>{children}</DropdownButton>
      </Dropdown>
    </DropdownButtonWrapper>
  );
};

export default BuiltInDropdown;
